<template lang="">
    <div>
        <div class="chat1">
            <div class="row justify-content-center my-4 pr-2" role="status" v-if="!alerte">
                <div class="loading"></div>
            </div>
                            <div class="container-fluid w-100" v-if="alerte != undefined">
                                <ModalAlerte :modal_id="'modal'+alerte.uuid" :alerte="alerte" @clickClose="$bvModal.hide('modal'+item.uuid)" @click="meet = false, (setLoader = false)"/>
                                    <div class="d-flex justify-content-between w-100" v-if="alerte.creator">
                                        <span class="m-0 default fwb text-start fs-6"> <span class="fwB"> Alerte par:</span> {{alerte.creator.name}}</span>
                                        <span class="m-0 default fwb text-center fs-6"><span class="fwB">Date - Heure:</span> {{alerte.created_at}}</span>
                                        <!-- <div class="px-3 py-1"><span class="m-0 default fwb text-end fs-6">Statut: {{alerte.statut.valeur}}</span></div> -->
                                        <div class="m-0 px-3 py-1 mt--1"><b-badge class="m-0 default fwb text-end fs-6" :variant="changeColor(alerte.statut.id)"><span class="fwB">Statut:</span> {{ alerte.statut.valeur }}</b-badge></div>
                                    </div>
                                    <div><p class="mt-3 title-text" v-if="!hasPatientRole">Informations du souscripteur</p></div>
                                    <ul class="list-none p-0 notification-card-content pt-3" v-if="alerte.creator && !hasPatientRole">
                                        <li class="d-flex justify-content-between w-100">
                                            <div class="d-flex justify-content-between w-100 my-2">
                                                <span class="m-0 default fwb text-start"><span class="fwB">Nom:</span> {{alerte.creator.name}}</span>
                                                <span class="m-0 default fwb text-center"><span class="fwB">Email:</span> {{alerte.creator.email}}</span>
                                                <span class="m-0 default fwb text-end"><span class="fwB">Téléphone:</span> {{alerte.creator.telephone}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <div  class=""><p class="text-dark title-text">Informations du patient</p></div>
                                    <ul class="list-none p-0 notification-card-content pt-4 w-100" v-if="alerte.patient">
                                        <li class="w-100">
                                            <div class="d-flex justify-content-between w-100 mb-3">
                                                <span class="m-0 default fwb text-start fs-6"><span class="fwB">Nom:</span> {{alerte.patient.name}}</span>
                                                <span class="m-0 default fwb text-center fs-6"><span class="fwB">Email:</span> {{alerte.patient.email}}</span>
                                                <span class="m-0 default fwb text-end fs-6"><span class="fwB">Sexe:</span> {{ alerte.patient.patient != null ? alerte.patient.patient.sexe : ''}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between w-100 mb-3">
                                                <span class="m-0 default fwb text-start fs-6"><span class="fwB">Téléphone:</span> {{alerte.patient.telephone}}</span>
                                                <span class="m-0 default fwb text-center fs-6"><span class="fwB">Date de naissance:</span> {{ alerte.patient.patient != null ? alerte.patient.patient.date_de_naissance : ''  }} </span>
                                                <div></div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="list-none p-0 notification-card notification-urgence pt-4">
                                        <div class="d-inline-flex circular-red px-3 mb-3"><p class=""><span class="fwB">Niveau d'urgence:</span>  {{alerte.niveau_urgence_id}}</p></div>
                                        <p class="mt-1"><span class="fwB">Plainte:</span> {{ alerte.plainte }}</p>
                                        <div class="row w-100 py-2">
                                            <div class="col-sm-12 col-md-6 w-100 px-0" v-if="alerte.audio">
                                                <audio controls>
                                                    <source :src="alerte.audio" type="audio/mpeg">Your browser does not support the audio tag.
                                                </audio>
                                            </div>
                                            <div class="col-sm-12 col-md-6 px-0" v-if="alerte.audio1">
                                                <audio controls>
                                                    <source :src="alerte.audio1" type="audio/mpeg">Your browser does not support the audio tag.
                                                </audio>
                                            </div>
                                        </div>
                                    </ul>
                                    <div v-can="'Affecter un médecin controle à une alerte'"><p class="mt-3 title-text">Affecter l'alerte à un médecin</p></div>
                                    <ul class="list-none p-0 notification-card notification-urgence py-4" v-can="'Affecter un médecin controle à une alerte'"> 
                                        <div class="row justify-content-center my-4 pr-2" role="status" v-if="load">
                                            <div class="loading"></div>
                                        </div>
                                        <b-alert variant="success" show v-if="message" dismissible>Affectation avec succes</b-alert>
                                        <div v-if="alerte.medecin_id != null"> <span>Médecin: {{alerte.medecin.name}}</span> 
                                            <!-- <p>Vous pouvez le modifier directement ici!1!</p> -->
                                        </div>
                                        <div class="m-0 mb-3 w-100"><p class=""> Selectionnez un médecin <span class="text-danger">*</span></p>
                                            <b-form-group
                                                class="pl-0 w-100"
                                                id="id"
                                                label-for="responsable">
                                                <div class="row w-100">
                                                    <div class="col-md-9 col-sm-6 w-100 my-1 align-self-start">
                                                        <multiselect
                                                            class="mx-0"
                                                            v-model="medecin.medecin_id"
                                                            :options="medecins"
                                                            label="nom" track-by="id"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            placeholder="Rechercher le medécin soignant">
                                                        </multiselect>
                                                        <p v-if="erreur" class="text-danger">{{ "Sélectionnez le médecin" }}</p>
                                                    </div>
                                                    <div class="my-1 w-100 col-md-3 col-sm-12">
                                                        <button @click="onAddReferent" class="btn btn-outline-dark w-100"> <i class="fas fa-plus mr-1"></i>Affecter</button>
                                                    </div>
                                                </div>
                                            </b-form-group>
                                        </div>
                                    </ul>
                                    <div class="w-100 mt-4">
                                      <!--   <div class=""> <a href="/alertes" @click="" class="text-primary">Voir tous les alertes</a></div> -->
                                        <div class=" d-flex justify-content-between">
                                            <div class="d-flex flex-column align-items-center w-100">
                                                <!-- {{ url_moderator }} loader{{getLoader}} -->
                                                <div class="mb-3">
                                                    <button v-if="alerte.medecin_id != null && hasMedecinControleRole" v-can="'Créer une téléconsultation'" @click="OpenTeleconsultation(alerte.patient.id, alerte.patient.slug)" class="btn btn-default">Faire une téléconsultation</button>
                                                    <a href="" v-if="hasAssistante" @click="viewTrajetPatient" class="text-primary mx-0 px-0">Verifier la validité des CIMS</a>
                                                </div>
                                                <div class="row justify-content-center my-4 pr-2" role="status" v-if="getLoader">
                                                    <div class="loading"></div>
                                                </div>
                                                <div class="border-top w-100 text-center py-3" v-if="meet && !getLoader">
                                                    <button v-if="alerte.medecin_id != null && hasMedecinControleRole" v-can="'Créer une téléconsultation'" @click="openFormTeleconsultation(alerte.patient.slug)" class="btn btn-primary mb-2 text-center"><i class="fa fa-clipboard mx-1"></i>Poursuivre vers le formulaire</button>
                                                    <div class="d-flex justify-content-center">
                                                        <button class="circle-button btn bg-primary shadow"><i class="text-white fa fa-phone fa-2x"></i></button>
                                                        <button class="circle-button btn bg-default b-video shadow text-white" @click="OpenVideoMeet(alerte.patient.slug)"><i class="fa fa-video fa-2x"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end w-100">
                                                <!-- <button v-if="alerte.medecin_id == null && hasAssistante" @click="OpenTeleconsultation(alerte.patient.slug)" class="btn btn-outline-danger"><i class="fas fa-trash mr-2"></i>Rejeter</button> -->
                                                <button v-if="alerte.medecin_id == null && hasSouscripteurRole || hasAssistante || hasPatientRole" v-can="'Modifier une alerte'" @click="getAlerte(alerte)" class="btn btn-primary"><i class="fas fa-edit mr-2 px-1"></i>Modifier</button>
                                                <button v-if="alerte.medecin_id == null && hasSouscripteurRole || hasPatientRole" v-can="'Supprimer une alerte'" @click="$emit('clickDelete')" class="btn btn-outline-danger"><i class="fas fa-trash mr-2"></i>Supprimer</button>
                                            </div>
                                        </div>
                                    </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import BaseSelected from '@/components/BaseSelected.vue'
import store from '@/store/store.js'
import { mapGetters, mapMutations } from "vuex";
import Multiselect from 'vue-multiselect';
import ModalAlerte from "./../views/Alerte/ModalAlerte.vue"
import SlimSelect from "slim-select";
import axios from 'axios';
import Vue from 'vue';
import AppConfig from '../constants/AppConfig';
export default {
    props: ['uuid', 'file_id','moreDetails','alerte'],
    components: { BaseSelected, Multiselect, ModalAlerte },
    computed: {
        ...mapGetters(["file", 'medecins','hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasSouscripteurRole', 'hasPatientRole', 'hasPraticienRole', 'alertes', 'url_patient', 'url_moderator', 'getLoader'])
    },
    data() {
        return {
            load: false,
            message: false,
            erreur: false,
            meet: false,
            value: '',
            liste_medecins: [],
            medecin: {
                medecin_id: '',
            },
        }
        
    },
    methods: {
        changeColor(item) {
            if (item === 1) {
                return 'warning';
            }
            else if (item === 2) {
                return 'success';
            }
            else if (item === 3) {
                return 'primary';
            }
            else if (item === 4) {
                return 'danger';
            }
		},
        viewTrajetPatient(params){
            this.$emit('clickClose');
                //  console.log(this.file.slug);
                this.$router.push(  (this.$router.resolve({ name: 'trajet-patient',  params: { file: this.alerte.patient.dossier.slug } })).href +  '#generale');
            }, 
        getAlerte(item){
            this.$emit('clickClose');
            // console.log('item ', item)
            //this.alerte = item;
            this.$bvModal.show('modal'+item.uuid);
        },
        Modify(){
            this.moreDetails= false
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
       
        onAddReferent() {

            if (this.medecin.medecin_id.id == undefined) {
                this.erreur = true
                return;
            }

            this.load=true;
            this.erreur = false
            const args = {};
            //let self = this;

            const successMessage = this.$i18n.t('message.followedUpCreated');
            const errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
            };
            axios.patch(AppConfig.apiUrl + '/v2/alertes/'+this.alerte.id+'/assignMedecin', { medecin_id: this.medecin.medecin_id.id}, { headers: { 'Authorization': "Bearer " + localStorage.getItem('ms-token') } }).then(res => {
                this.load = false,
                Vue.swal("Le médecin a été affecter avec succès", '', 'success');
                this.$store.commit('getAlerteHandler', res.data);
                let data = this.alertes.data.map(item => item.id == res.data.id ? res.data : item);
                let alertes = {...this.alertes, data: data};
                this.$store.commit('getAlertesHandler', { alertes: alertes });
                this.$emit('clickClose');
            }).catch(error => {
                console.log('error ', error);
            });
            // const payload = { args, errorMessages, successMessage };
            // this.$store.dispatch("addDoctorToAlerte", payload)

        },
        ...mapMutations(['setLoader']),
        OpenTeleconsultation(patient_id){
            
            let args = {
                user_id: patient_id
            };
            this.$store.dispatch('createMettgingAndJoinAsModerator', { args: args }).t
            this.$store.dispatch('createMettgingAndJoinAsPatient', { args: args }).then(() => {
                this.meet = true;
            })
        },
        OpenVideoMeet(patient_slug){
            this.$emit('clickClose');
            window.open(this.url_moderator, "_blank");
            // this.url_patient
            window.location.href =`${AppConfig.teleconsultationUrl}?project=${patient_slug}&slug=${patient_slug}&ms=${localStorage.getItem('ms-token')}`;
            this.meet = false;
        },
        openFormTeleconsultation(patient_slug){
            this.$emit('clickClose');
            window.location.href =`${AppConfig.teleconsultationUrl}?project=${patient_slug}&slug=${patient_slug}&ms=${localStorage.getItem('ms-token')}`;
        },
        getSearchPatient(patient) {
            this.loading = true;
            fetch(AppConfig.apiUrl + `/v2/patients?search=${patient}`, { headers: { 'Authorization': "Bearer " + localStorage.getItem('ms-token') } })
                .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.liste_patient = res
                }).catch(error => {
                    console.log('error', error);
                })
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getMedecins(page = 1, search = "", size = 25, statut_id = "") {
            let args = {
                page: page,
                search: search,
                size: size,
                statut_id: statut_id,
            };

            this.$store.dispatch('getMedecins', { args: args });
        },
    },
    mounted() {
        //this.$store.dispatch('clearUrlUser');
        this.$store.dispatch('getAlerte', this.uuid);
        this.getMedecins()
    },
}
</script>
<style lang="" src="vue-multiselect/dist/vue-multiselect.min.css">
    
</style>